<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor mgb-15"
      @click="$router.go(-1)"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <!-- 分区信息展示 -->
    <el-descriptions
      class="margin-top"
      title=""
      :column="1"
      size="medium"
      border
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location"></i>
          分区名称：
        </template>
        {{ regionInfo.regionName || "xxx" }}
      </el-descriptions-item>
    </el-descriptions>
    <div style="margin: 5px 0; height: 1px"></div>

    <!-- 订单查询表单 -->
    <el-form
      :inline="true"
      ref="searchForm"
      :model="searchForm"
      class="search-form"
    >
      <el-form-item label="订单编号">
        <el-input
          v-model="searchForm.orderNo"
          placeholder="请输入订单编号"
          clearable
          style="width: 200px"
        ></el-input>
      </el-form-item>

      <el-form-item label="水卡编号">
        <el-input
          v-model="searchForm.waterCard"
          placeholder="请输入水卡编号"
          clearable
          style="width: 200px"
        ></el-input>
      </el-form-item>

      <el-form-item label="客户电话">
        <el-input
          v-model="searchForm.phone"
          placeholder="请输入客户电话"
          clearable
          style="width: 200px"
        ></el-input>
      </el-form-item>

      <el-form-item label="充值方式">
        <el-select
          v-model="searchForm.orderType"
          placeholder="请选择充值方式"
          clearable
          multiple
          collapse-tags
          style="width: 220px"
        >
          <el-option label="用户套餐充值" :value="1"></el-option>
          <el-option label="活动套餐充值" :value="2"></el-option>
          <el-option label="活动充值" :value="3"></el-option>
          <el-option label="小程序活动套餐充值" :value="19"></el-option>
          <el-option label="接卡" :value="4"></el-option>
          <el-option label="套餐过期(扣减余额)" :value="5"></el-option>
          <el-option label="水卡清零(扣减余额)" :value="6"></el-option>
          <el-option label="区域迁移充值" :value="7"></el-option>
          <el-option label="订单补偿" :value="8"></el-option>
          <el-option label="合伙人提现" :value="9"></el-option>
          <el-option label="合伙人套餐充值" :value="20"></el-option>
          <el-option label="首次充值奖励" :value="10"></el-option>
          <el-option label="新用户绑卡奖励" :value="11"></el-option>
          <el-option label="余额转移(增加余额)" :value="13"></el-option>
          <el-option label="余额转移(扣减余额)" :value="14"></el-option>
          <el-option label="小程序活动套餐充值" :value="19"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="充值日期">
        <el-date-picker
          v-model="searchForm.startTime"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          style="width: 140px"
        ></el-date-picker>
        至
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 140px"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getOrderList()">查询</el-button>
        <el-button @click="resetSearch()">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 订单表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%; margin-top: 15px"
      v-loading="loading"
    >
      <el-table-column prop="index" label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column
        prop="orderNo"
        label="订单编号"
        min-width="200"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="waterCard"
        label="水卡编号"
        min-width="120"
        align="center"
      ></el-table-column>

      <!-- 客户电话脱敏处理 -->
      <el-table-column
        prop="phone"
        label="客户电话"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span class="phone-text">{{ maskPhone(scope.row.phone) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="orderType"
        label="充值方式"
        min-width="140"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ getRechargeTypeName(scope.row.orderType) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="payTime"
        label="充值时间"
        min-width="160"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="payPrice"
        label="实付金额(元)"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text">{{ scope.row.payPrice || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="canRefund"
        label="是否退款"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.refundPrice > 0 ? 'danger' : 'success'"
            size="small"
          >
            {{ scope.row.refundPrice > 0 ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="refundPrice"
        label="退款金额"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <span class="refund-text">{{ scope.row.refundPrice || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column label="实际销售(元)" min-width="110" align="center">
        <template slot-scope="scope">
          <span class="sales-text">{{ calculateActualSales(scope.row) }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="prev, pager, next, sizes, total"
      :total="total"
      style="text-align: center; margin-top: 20px"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      loading: false,

      // 分区信息
      regionInfo: {
        regionName: "",
        regionId: null,
      },

      // 搜索表单 - 使用API实际字段名
      searchForm: {
        orderNo: "", // 订单编号
        waterCard: "", // 水卡编号
        phone: "", // 客户电话
        orderType: [], // 订单类型(充值方式) - 改为数组
        startTime: "", // 开始时间
        endTime: "", // 结束时间
      },

      // 表格数据
      tableData: [],

      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 充值方式映射 - 根据API的orderType字段
      rechargeTypeMap: {
        1: "用户套餐充值",
        2: "活动套餐充值",
        3: "活动充值",
        4: "接卡",
        5: "套餐过期(扣减余额)",
        6: "水卡清零(扣减余额)",
        7: "区域迁移充值",
        8: "订单补偿",
        9: "合伙人提现",
        10: "首次充值奖励",
        11: "新用户绑卡奖励",
        13: "余额转移(增加余额)",
        14: "余额转移(扣减余额)",
        19: "小程序活动套餐充值",
        20: "合伙人套餐充值",
      },
    };
  },

  created() {
    // 获取路由传递的分区信息
    this.regionInfo = JSON.parse(this.$route.query.data || "{}");
    this.getOrderList();
  },

  methods: {
    // 手机号脱敏处理：显示前3位后4位，中间用****代替
    maskPhone(phone) {
      if (!phone) return '';
      
      // 转为字符串并去除空格
      const phoneStr = String(phone).replace(/\s+/g, '');
      
      // 如果长度不足11位，直接返回原值
      if (phoneStr.length < 11) {
        return phoneStr;
      }
      
      // 提取前3位和后4位，中间用****代替
      const prefix = phoneStr.substring(0, 3);
      const suffix = phoneStr.substring(phoneStr.length - 4);
      
      return `${prefix}****${suffix}`;
    },

    // 获取订单列表 - 使用真实API
    getOrderList(pageNum) {
      if (!pageNum) {
        this.currentPage = 1;
      }

      this.loading = true;

      const params = {};

      // 基础分页参数必须传递
      params.pageNum = this.currentPage;
      params.pageSize = this.pageSize;
      params.isStaffAchievement = true; // 员工业绩查询标识
      
      // 将regionId转为数组形式
      if (this.regionInfo.regionId) {
        // 如果已经是数组则使用，否则转为数组
        params.regionId = Array.isArray(this.regionInfo.regionId)
          ? this.regionInfo.regionId
          : [this.regionInfo.regionId];
      }

      // 条件性添加其他查询参数
      if (this.searchForm.orderNo) params.orderNo = this.searchForm.orderNo;
      if (this.searchForm.phone) params.phone = this.searchForm.phone;
      
      // orderType数组处理：只有当数组不为空时才传递
      if (this.searchForm.orderType && this.searchForm.orderType.length > 0) {
        params.orderType = this.searchForm.orderType;
      }
      
      if (this.searchForm.waterCard)
        params.waterCard = this.searchForm.waterCard;
      if (this.searchForm.startTime)
        params.startTime = this.searchForm.startTime;
      if (this.searchForm.endTime) params.endTime = this.searchForm.endTime;

      console.log('API请求参数:', params); // 调试用，可以删除

      this.$api.order
        .topOrderList(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            // 使用API返回的数据结构
            this.tableData = res.data.rows || [];
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.message || "获取订单列表失败");
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取订单列表失败:", error);
          this.$message.error("获取订单列表失败，请稍后重试");
          this.tableData = [];
          this.total = 0;
        });
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        orderNo: "",
        waterCard: "",
        phone: "",
        orderType: [], // 重置为空数组
        startTime: "",
        endTime: "",
      };
      this.currentPage = 1;
      this.getOrderList();
    },

    // 获取充值方式名称
    getRechargeTypeName(type) {
      return this.rechargeTypeMap[type] || "未知";
    },

    // 计算实际销售金额
    calculateActualSales(row) {
      const payPrice = parseFloat(row.payPrice) || 0;
      const refundPrice = parseFloat(row.refundPrice) || 0;
      return (payPrice - refundPrice).toFixed(2);
    },

    // 分页大小改变
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.getOrderList();
    },

    // 当前页改变
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getOrderList(newPage);
    },
  },
};
</script>

<style lang="scss" scoped>
// 返回链接样式
.topReturnLink {
  color: var(--accent);
  cursor: pointer;
  margin-bottom: 15px;

  &:hover {
    color: #66b1ff;
  }

  i {
    margin-right: 5px;
  }
}

// 查询表单样式
.search-form {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
  border: 1px solid #e9ecef;

  .el-form-item {
    margin-bottom: 15px;
  }
}

// 金额文字样式
.amount-text {
  font-weight: 500;
  color: var(--text-sub);
}

.refund-text {
  color: var(--danger);
  font-weight: 500;
}

.sales-text {
  color: var(--accent);
  font-weight: 600;
}

// 电话号码样式
.phone-text {
  color: var(--text-sub);
  font-family: 'Consolas', 'Monaco', monospace;
  letter-spacing: 1px;
}

// 表格样式优化
::v-deep .el-table {
  .el-table__header {
    th {
      background-color: #f8f9fa;
      color: var(--text-sub);
      font-weight: 600;
    }
  }

  .el-table__body {
    tr:hover {
      background-color: #f0f9ff;
    }
  }
}

// 标签样式
::v-deep .el-tag {
  border: none;

  &.el-tag--success {
    background-color: #f0f9ff;
    color: var(--accent);
  }

  &.el-tag--danger {
    background-color: #fef0f0;
    color: var(--danger);
  }
}

// 多选下拉框样式优化
::v-deep .el-select {
  .el-select__tags {
    max-width: calc(100% - 30px);
    overflow: hidden;
  }
}

// 分页样式
::v-deep .el-pagination {
  .el-pager li.active {
    background-color: var(--accent);
    color: white;
  }
}

// 描述列表样式
::v-deep .el-descriptions {
  .el-descriptions__label {
    font-weight: 600;
    background: var(--card-bg);
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .search-form {
    .el-form-item {
      margin-right: 10px;
    }
  }
}
</style>
